import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import 'chartjs-plugin-deferred';

//Flickity Slider
import Flickity from 'flickity';
import 'flickity-imagesloaded/flickity-imagesloaded';
//GSAP
import {
    gsap
} from "gsap";
import {
    ScrollTrigger
} from "gsap/ScrollTrigger"
gsap.registerPlugin(ScrollTrigger);

export function businessOwnersGuide() {

    if (document.querySelector('body.business-owners-guide')) {

        var wasteCrimeChart = document.getElementById('waste-crime-chart');
        if (wasteCrimeChart) {

            Chart.plugins.register(ChartDataLabels);

            Chart.defaults.global.defaultFontFamily = '"raleway", -apple-system, system-ui, BlinkMacSystemFont, "SF Display", "Helvetica Neue", "Helvetica", Arial, sans-serif';

            var myChart = new Chart(wasteCrimeChart, {
                type: 'horizontalBar',
                data: {
                    labels: window.wasteCrimeChart.dataReverse.labels,
                    datasets: [{
                        data: window.wasteCrimeChart.dataReverse.data,
                        backgroundColor: '#065093',
                        datalabels: {
                            align: 'end',
                            anchor: 'end'
                        }
                    }]
                },
                options: {
                    animation: {
                        duration: 3000
                    },
                    legend: {
                        display: false,
                    },
                    tooltips: {
                        enabled: false
                    },
                    plugins: {
                        datalabels: {
                            color: '#F8B223',
                            font: {
                                weight: 'bold',
                                size: 20
                            }
                        },
                        deferred: {
                            yOffset: '50%', // defer until 50% of the canvas height are inside the viewport
                            delay: 500 // delay of 500 ms after the canvas is considered inside the viewport
                        }
                    },
                    layout: {
                        padding: {
                            right: 50
                        }
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                fontColor: '#065093',
                                fontSize: '20'
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                fontColor: '#065093',
                                fontStyle: 'bold',
                                fontSize: '20'
                            },
                            scaleLabel: {
                                display: true,
                                labelString: window.wasteCrimeChart.xLabel,
                                fontSize: 18
                            }
                        }]
                    }
                }
            });
        }

        var acc = document.querySelectorAll(".accordion");
        [...acc].forEach(function (v, i, a) {
            var toggle = v.querySelector('.faq');
            toggle.addEventListener('click', function () {
                this.classList.toggle("active");

                var panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        });

        var wasteWorkCarousel = document.querySelector('.waste-work-carousel');

        if (wasteWorkCarousel) {
            var flickityWasteWorkCarousel = new Flickity(wasteWorkCarousel, {
                prevNextButtons: true,
                cellAlign: 'center',
                imagesLoaded: true,
            });
        }

        var practicalCarousel = document.querySelector('.practical-carousel');
        if (practicalCarousel) {
            var flickityPracticalCarousel = new Flickity(practicalCarousel, {
                prevNextButtons: true,
                cellAlign: 'center',
                imagesLoaded: true,
            });
        }

        let lastKnownScrollPosition = 0;
        let ticking = false;

        function getOffset(el) {
            var rect = el.getBoundingClientRect(),
                scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return {
                top: rect.top + scrollTop,
                left: rect.left + scrollLeft
            }
        }

        function pagerScroll(scrollPos) {

            var pagers = document.querySelectorAll('.pager');
            var scrollPosAdjusted = scrollPos - getOffset(pagers[0]).top;

            var nav = document.querySelector('nav .steps');
            var navSteps = nav.querySelectorAll('.steps .step');

            [...pagers].forEach(function (v, i, a) {

                if (i > 0) {

                    var top = getOffset(v).top;
                    var prevTop = getOffset(a[i - 1]).top;
                    var range = top - prevTop;
                    var sectionScroll = scrollPos - prevTop;
                    var cent = (sectionScroll / range) * 100;
                    var actualCent;
                    var atBottom = (window.innerHeight + window.scrollY) >= document.body.offsetHeight;

                    if (cent < 0) {
                        actualCent = 0;
                    } else if (cent > 100 || atBottom) {
                        actualCent = 100;
                    } else {
                        actualCent = cent;
                    }

                    navSteps[i - 1].querySelector('.active-line').style.height = actualCent + '%';

                    if (cent == 0 || cent > 0) {
                        navSteps[i - 1].classList.add('active');
                    } else {
                        navSteps[i - 1].classList.remove('active');
                    }

                    // last section can't scroll to top of window, so when scroll reaches bottom of page, mark the nav as active
                    if (atBottom) {
                        navSteps[navSteps.length - 1].classList.add('active');
                    } else {
                        navSteps[navSteps.length - 1].classList.remove('active');
                    }

                }
            });
        }

        function hierarchyArrowPosition() {
            // center hierarchy arrows
            var hierarchyArrows = document.querySelectorAll('.gsap-hierarchy-arrows > div');
            var hierarchyPyramid = document.querySelectorAll('.gsap-hierarchy-pyramid > div');
            [...hierarchyArrows].forEach(function (v, i, a) {
                var pyramidHeight = hierarchyPyramid[i].getBoundingClientRect().height;
                console.log(pyramidHeight);
                var arrowHeight = v.getBoundingClientRect().height;
                console.log(arrowHeight);
                var top = (pyramidHeight * i) + (pyramidHeight / 2) - (arrowHeight / 2);
                console.log(top);
                v.style.top = top + 'px';
            });
        }
        hierarchyArrowPosition();

        window.onresize = hierarchyArrowPosition;

        document.addEventListener('scroll', function (e) {
            lastKnownScrollPosition = window.scrollY;

            if (!ticking) {
                window.requestAnimationFrame(function () {
                    pagerScroll(lastKnownScrollPosition);
                    ticking = false;
                });

                ticking = true;
            }
        });

        // GSAP Animations

        //bog-header-bin
        gsap.fromTo(
            "#gsap-header-bin", {
                scale: 0,
                opacity: 0,
            }, {
                scale: 1,
                opacity: 1,
                duration: 2,
                delay: 1,
                ease: 'elastic.out'
            }
        );

        var gsapContentsPs = document.querySelectorAll('#gsap-contents p');
        [...gsapContentsPs].forEach(function (v, i, a) {
            gsap.from(
                v, {
                    scrollTrigger: {
                        trigger: v,
                        scrub: false,
                        start: "top 80%",
                        toggleActions: "play none none reverse"
                    },
                    opacity: 0,
                    duration: 1,
                    ease: 'none'
                }
            );
        });

        var gsapFade = document.querySelectorAll('.gsap-fade');
        [...gsapFade].forEach(function (v, i, a) {
            gsap.from(
                v, {
                    scrollTrigger: {
                        trigger: v,
                        scrub: false,
                        start: "top 80%",
                        toggleActions: "play none none reverse"
                    },
                    opacity: 0,
                    duration: 1,
                    ease: 'none'
                }
            );
        });

        var gsapFadePs = document.querySelectorAll('.fade-ps p, .fade-ps ul');
        [...gsapFadePs].forEach(function (v, i, a) {
            gsap.from(
                v, {
                    scrollTrigger: {
                        trigger: v,
                        scrub: false,
                        start: "top 80%",
                        toggleActions: "play none none reverse"
                    },
                    opacity: 0,
                    duration: 1,
                    ease: 'none'
                }
            );
        });

        var gsapIconFadeContainer = document.querySelectorAll('.gsap-icon-fade');
        [...gsapIconFadeContainer].forEach(function (v, i, a) {
            var delay = 0;
            [...v.querySelectorAll('div')].forEach(function (value, index, array) {
                delay = 0.2 * index;
                gsap.from(
                    value, {
                        scrollTrigger: {
                            trigger: v,
                            scrub: false,
                            start: "top 80%",
                            toggleActions: "play none none reverse"
                        },
                        opacity: 0,
                        duration: 1,
                        ease: 'none',
                        delay: delay
                    }
                );
            });
        });

        var gsapHierarchyPyramid = document.querySelectorAll('.gsap-hierarchy-pyramid');
        var gsapHierarchyArrows = document.querySelectorAll('.gsap-hierarchy-arrows');
        var gsapHierarchyIncludes = document.querySelectorAll('.gsap-hierarchy-includes');

        [...gsapHierarchyPyramid].forEach(function (v, i, a) {

            var gsapPyramidTL = gsap.timeline({
                scrollTrigger: {
                    trigger: v,
                    scrub: 1.5,
                    start: "top 80%",
                    end: "bottom 70%",
                    toggleActions: "play none none reset"
                },
                repeat: 0
            });

            var gsapHierarchyArrow = gsapHierarchyArrows[i].querySelectorAll('div');
            var gsapHierarchyInclude = gsapHierarchyIncludes[i].querySelectorAll('div');

            [...v.querySelectorAll('div')].forEach(function (value, index, array) {

                gsap.set(value, {
                    y: function (gsapindex, target, targets) {
                        var offset = target.offsetTop;
                        var height = target.getBoundingClientRect().height;
                        var startPosition = -Math.abs(offset + height);
                        return startPosition;
                    }
                });

                gsapPyramidTL.to(
                    value, {
                        y: function (gsapindex, target, targets) {
                            var height = target.getBoundingClientRect().height;
                            var startPosition = -(height);
                            return startPosition;
                        },
                        duration: 0
                    });

                gsapPyramidTL.to(
                    value, {
                        y: 0,
                        ease: 'power2.inOut'
                    });

                gsapPyramidTL.from(
                    gsapHierarchyArrow[index], {
                        opacity: 0,
                        ease: 'none'
                    },
                    "<90%"
                );
                gsapPyramidTL.from(
                    gsapHierarchyInclude[index], {
                        opacity: 0,
                        ease: 'none'
                    },
                    "<75%"
                );
            });
        });

        var gsapWasteCrime = document.querySelectorAll('.gsap-waste-crime');

        [...gsapWasteCrime].forEach(function (v, i, a) {

            const arrow = v.querySelector('.arrow');
            const stuff = v.querySelectorAll('.content > *');

            gsap.from(
                arrow, {
                    scrollTrigger: {
                        trigger: v,
                        scrub: false,
                        start: "top 75%",
                        toggleActions: "play none none reverse"
                    },
                    rotate: '-90deg',
                    duration: 2,
                    ease: 'elastic.out(1, 0.3)',
                    transformOrigin: 'center'
                }
            );

            var delay = 0;
            [...stuff].forEach(function (val, ind, ara) {
                delay = delay + 0.2;

                gsap.from(
                    val, {
                        scrollTrigger: {
                            trigger: v,
                            scrub: false,
                            start: "top 75%",
                            toggleActions: "play none none reverse"
                        },
                        opacity: 0,
                        duration: 2,
                        delay: delay
                    }
                );
            });

        });

        const gsapTruckOnRoad = document.querySelector('.gsap-truck-on-road');

        var gsapTruckOnRoadTL = gsap.timeline({
            scrollTrigger: {
                trigger: document.querySelector('.road'),
                start: "top 70%",
                scrub: 1
            }
        });

        gsapTruckOnRoadTL.fromTo(
            gsapTruckOnRoad, {
                x: function (gsapindex, target, targets) {
                    return document.body.clientWidth;
                }
            }, {
                x: function (gsapindex, target, targets) {
                    return -target.offsetWidth;
                }
            }
        );

        const clock = document.querySelector('.clock');
        const hourHand = clock.querySelector('.hour-hand');
        const minuteHand = clock.querySelector('.minute-hand');
        const secondHand = clock.querySelector('.second-hand');

        var gsapClockTL = gsap.timeline({
            scrollTrigger: {
                trigger: clock,
                start: "center 95%",
                end: "top 5%",
                scrub: 1
            }
        });


        var svgMultiplier = 1.513886

        var transformOxHH = 68 * svgMultiplier;
        var transformOyHH = 104 * svgMultiplier
        gsapClockTL.to(hourHand, {
                rotate: '30deg',
                transformOrigin: transformOxHH + "px " + transformOyHH + "px"
            },
            'clockGo');

        var transformOxMH = 35 * svgMultiplier;
        var transformOyMH = 82 * svgMultiplier
        gsapClockTL.to(minuteHand, {
                rotate: '360deg',
                transformOrigin: transformOxMH + "px " + transformOyMH + "px"
            },
            'clockGo');

        var transformOxSH = 58 * svgMultiplier;
        var transformOySH = 59 * svgMultiplier
        gsapClockTL.to(secondHand, {
                rotate: '21600deg',
                transformOrigin: transformOxSH + "px " + transformOySH + "px"
            },
            'clockGo');

        function numberWithCommas(x) {
            var parts = x.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return parts.join(".");
        }

        const counters = document.querySelectorAll('.gsap-counter');

        [...counters].forEach(function (v, i, a) {

            var snap = v.classList.contains('gsap-step-float') ? 0.1 : 1;
            gsap.from(v, {
                scrollTrigger: {
                    trigger: v,
                    scrub: false,
                    start: "top 80%",
                    toggleActions: "play none none reverse"
                },
                textContent: 0,
                duration: 1.5,
                snap: {
                    textContent: snap
                },
                stagger: {
                    each: 1.0,
                    onUpdate: function () {
                        this.targets()[0].innerHTML = numberWithCommas(this.targets()[0].textContent);
                    },
                },
                ease: 'power2.inOut'
            });

        });

        const gsapBinMan = document.querySelector('.gsap-bin-man');

        gsap.from(gsapBinMan, {
            scrollTrigger: {
                trigger: gsapBinMan,
                scrub: 1,
                end: 'top 70%'
            },
            scale: 0,
            transformOrigin: 'center bottom'
        });

    }
}